import {RootState} from '../State';
import {KeyedAction, StoreAPI} from '../Store';
import {LaunchBarSize, WindowState} from '../../view/utils/constants';

export type LaunchBarState = Readonly<{
    visible: boolean;
    size: LaunchBarSize;
    windowState: WindowState;
}>;

export const LaunchBarInitialState: LaunchBarState = {
    visible: false,
    size: LaunchBarSize.NORMAL,
    windowState: WindowState.NORMAL
};

export class SetLaunchBarWindowState extends KeyedAction<RootState, 'launchBar'> {
    public readonly type: string = '@@LAUNCHBAR/SET_WINDOW_STATE';

    constructor(public readonly windowState: WindowState) {
        super('launchBar');
    }

    public async call(store: StoreAPI<RootState>, complete: () => Promise<void>): Promise<void> {
        if (store.state.launchBar.windowState !== this.windowState) {
            await super.call(store, complete);
        }
    }

    public reduce(state: LaunchBarState): LaunchBarState {
        const {windowState} = this;

        return {
            ...state,
            windowState
        };
    }
}

export class SetLaunchBarVisibility extends KeyedAction<RootState, 'launchBar'> {
    public readonly type: string = '@@LAUNCHBAR/SET_VISIBILITY';

    constructor(public readonly visible: boolean) {
        super('launchBar');
    }

    public reduce(state: LaunchBarState): LaunchBarState {
        const {visible} = this;
        return {
            ...state,
            visible
        };
    }
}

export class SetLaunchBarSize extends KeyedAction<RootState, 'launchBar'> {
    public readonly type: string = '@@LAUNCHBAR/SET_SIZE';

    constructor(public readonly size: LaunchBarSize) {
        super('launchBar');
    }

    public async call(store: StoreAPI<RootState>, complete: () => Promise<void>): Promise<void> {
        if (store.state.launchBar.size !== this.size) {
            await super.call(store, complete);
        }
    }

    public reduce(state: LaunchBarState): LaunchBarState {
        const {size} = this;
        return {
            ...state,
            size
        };
    }
}
